<div class="filter-builder">

  <!-- Active filter pills -->
  @if (displayTableService.activeFilters()?.length) {
    <div class="filter-pills">
      @for (f of displayTableService.activeFilters(); track f.id) {
        <mat-chip
          (removed)="removeFilter(f.id)">
         <span matTooltip="Click to Edit Filter" class="filter-chip"
               (click)="editFilter(f); $event.stopPropagation(); $event.preventDefault()">
           {{ f.displayLabel }}
         </span>
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      }
    </div>
  }

  <!-- Builder row -->
  <div class="filter-row">

    <!-- Step 1: Column -->
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Column</mat-label>
      <mat-select data-cy="filter-column" [(ngModel)]="selectedColumn" (ngModelChange)="onColumnSelected()">
        @for (col of displayTableService.columnData; track col.label) {
          @if (col.field && (!activeFilterColumns().has(col.field)) || selectedColumn == col) {
            <mat-option [value]="col">{{ col.label }}</mat-option>
          }
        }
      </mat-select>
    </mat-form-field>

    <!-- Step 2: Operator -->
    @if (selectedColumn) {
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Operator</mat-label>
        <mat-select data-cy="filter-operator" #operatorSelect [(ngModel)]="selectedOperator"
                    (ngModelChange)="onOperatorSelected()">
          @for (op of availableOperators; track op) {
            <mat-option [value]="op">{{ operatorLabels[op] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <!-- Step 3: Value(s) -->
    @if (selectedOperator && needsValue) {

      @switch (selectedColumn?.type) {

        @case ('text') {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Value</mat-label>
            <input data-cy="filter-value-text" #valueInput matInput [(ngModel)]="value" (keyup.enter)="addFilter()" />
          </mat-form-field>
        }
        @case ('number') {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ needsValueTo ? 'From' : 'Value' }}</mat-label>
            <input data-cy="filter-value-number" #valueInput matInput type="number" [(ngModel)]="value"
                   (keyup.enter)="addFilter()" />
          </mat-form-field>
          @if (needsValueTo) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>To</mat-label>
              <input data-cy="filter-valueTo-text" matInput type="number" [(ngModel)]="valueTo"
                     (keyup.enter)="addFilter()" />
            </mat-form-field>
          }
        }
        @case ('select') {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Value</mat-label>
            <mat-select data-cy="filter-value-select" #valueInput [(ngModel)]="value"
                        multiple>
              @for (opt of selectedColumn?.options; track opt) {
                @if (typeof opt !== 'object') {
                  <mat-option data-cy="filter-value-select-options" [value]="opt">{{ opt }}</mat-option>
                } @else {
                  <mat-optgroup [label]="opt.value">
                    @for (subOpt of opt.subOptions; track subOpt) {
                      <mat-option [value]="subOpt">{{ subOpt }}</mat-option>
                    }
                  </mat-optgroup>
                }
              }
            </mat-select>
          </mat-form-field>
        }
        @case ('date') {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ needsValueTo ? 'From' : 'Date' }}</mat-label>
            <input data-cy="filter-value-date" #valueInput matInput [matDatepicker]="picker" [(ngModel)]="value" />
            <mat-datepicker-toggle matSuffix [for]="picker" />
            <mat-datepicker #picker />
          </mat-form-field>
          @if (needsValueTo) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>To</mat-label>
              <input data-cy="filter-valueTo-date" matInput [matDatepicker]="picker2" [(ngModel)]="valueTo" />
              <mat-datepicker-toggle matSuffix [for]="picker2" />
              <mat-datepicker #picker2 />
            </mat-form-field>
          }
        }

      }

    }

    <!-- Add button -->
    <button data-cy="filter-add" mat-flat-button color="primary"
            [disabled]="!isFormValid"
            (click)="addFilter()">
      Add Filter
    </button>

  </div>
</div>
